import {
    API,
    Auth
} from "aws-amplify";

const GET_PERSONAL_DETAILS = async function () {
    let apiName = "apief7338f8";
    let path = "/user-data/personal-details";
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        }
    };
    return await API.get(apiName, path, myInit)
}

const GET_USER_EXTERNAL_ACCOUNTS = async function () {
    let apiName = "apief7338f8";
    let path = "/user-data/personal-details/external-accounts";
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        }
    };
    return await API.get(apiName, path, myInit)
}

const GET_USER_ACTIVITY = async function () {
    let apiName = "apief7338f8";
    let path = "/user-data/activity";
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        }
    };
    return await API.get(apiName, path, myInit)
}


const DELETE_USER_EXTERNAL_ACCOUNT = async function (accountId) {
    let apiName = "apief7338f8";
    let path = "/user-data/personal-details/external-accounts/" + accountId;
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        }
    };
    return await API.del(apiName, path, myInit)
}

const CREATE_USER_EXTERNAL_ACCOUNT = async function (data) {
    let apiName = "apief7338f8";
    let path = "/user-data/personal-details/external-accounts";
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        },
        body: {
            data: data
        }
    };
    return await API.post(apiName, path, myInit)
}

const UPDATE_PERSONAL_DETAILS = async function (data) {
    let apiName = "apief7338f8";
    let path = "/user-data/personal-details";
    let myInit = {
        headers: {
            Authorization: (await Auth.currentSession()).idToken.jwtToken
        },
        body: {
            data: data
        }
    };
    return await API.put(apiName, path, myInit)
}

export {
    GET_PERSONAL_DETAILS,
    UPDATE_PERSONAL_DETAILS,
    GET_USER_EXTERNAL_ACCOUNTS,
    DELETE_USER_EXTERNAL_ACCOUNT,
    CREATE_USER_EXTERNAL_ACCOUNT,
    GET_USER_ACTIVITY
};